
import { cloneElement, useContext } from 'react'
import { stylesheet, classes, style } from 'typestyle'
import { important } from 'csx'

/* Components =================================================================================== */
import { Box } from '../../components/box/box.component'
import { Text } from '../../components/text/text.component'
import { FormActions, FormContext } from '../../components/form'
import { Button } from '../../components/button'

/* Core ========================================================================================= */
import { runOperator } from '../../core/operators'

/* Styles ======================================================================================= */
import { mb4 } from '../../styles/styleset/margin/mb4'
import { f15i } from '../../styles/styleset/font-size/f15i'
import { Tab } from '../../components/tab'

/* <FieldWrapper /> ============================================================================= */
export const FieldWrapper = (props: any) => {
  const { children, formValue, className, disableDelete, container } = props
  const { value, dispatch } = useContext(FormContext)
  const { form } = value

  const renderValue = () => {
    if (form?.[props.name] && form?.[props.name]?.error) {
      return (
        <Text size={'xs'} baseline={'error'}>
          {form[props.name].error}
        </Text>
      )
    } else if (formValue && formValue.error) {
      return (
        <Text size={'xs'} baseline={'error'}>
          {formValue && formValue.error && formValue.error}
        </Text>
      )
    }
  }

  const { disabled, hidden } = runOperator(props.type === 'group' ? props : children.props, {
    row: form,
  })

  if (hidden) {
    return <></>
  }

  if (container) {
    return cloneElement(children, { ...children.props, disabled, hidden })
  }

  return (
    <Box className={classes(className)} row baseline="none" rounded>
      <Box
        className={classes(mb4, disabled && STYLES.disabled)}
        baseline="none"
        spaceBetween
        alignCenterY
      >
        {props.label && props.type !== 'group' && (
          <Text as={<label htmlFor={props.name} />} baseline="surface" size={'sm'} shrink>
            {props.label}
          </Text>
        )}
        {((typeof formValue !== 'object' && formValue) ||
          (typeof formValue === 'object' && formValue?.value)) &&
          disableDelete && (
            <Button
              size="xs"
              baseline="none"
              icon={<i className={classes('material-icons-two-tone', f15i)}>close</i>}
              className={style({
                height: important('18px'),
                width: important('18px'),
                minWidth: important('18px'),
                minHeight: important('18px'),
                padding: important('4px'),
                $nest: {
                  span: {
                    width: important('18px'),
                    height: important('18px'),
                  },
                  i: {
                    width: important('18px'),
                    height: important('18px'),
                    lineHeight: important('18px'),
                  },
                },
              })}
              onClick={() => {
                ;(dispatch as any)?.({
                  type: FormActions.SET,
                  param: { name: props.name, value: '' },
                })
              }}
            />
          )}
      </Box>

      {cloneElement(children, { ...children.props, disabled, hidden })}
      {renderValue()}
    </Box>
  )
}

const STYLES = stylesheet({
  disabled: {
    color: 'rgb(160,160,160)',
  },
})
